<template>
    <BannerAbstract class="banner-community">

        <template #title>
            <i>Be Part of Our Community</i>
        </template>
        <template #message>
            <i>Connect with other users,</i> <i>share your creations,</i> <i>and get inspired!</i>
        </template>
        <template #actions>
            <v-btn 
                class="action"
                size="x-large" 
                elevation="0" 
                @click="handleJoin">
                <v-icon icon="fa-brands fa-discord"></v-icon>&nbsp;
                <span>Join our Discord</span>
            </v-btn>
        </template>

    </BannerAbstract>
</template>

<script>
import { mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import BannerAbstract from '@/components/common/banner/BannerAbstract.vue'

export default {
    name: 'BannerCommunity',
    components: {
        BannerAbstract
    },
    methods: {
        ...mapActions('router', [
            'openUrl'
        ]),
        handleJoin() {
            this.openUrl({
                url: 'https://discord.gg/8hwcxmgkv3',
                newTab: true
            })
        }
    }
}
</script>

<style>
.banner-community .content {
    padding-top: 75px !important;
}

.banner-community .content .title {
    font-size: 1.5rem !important;
    text-align: center !important;
}

.banner-community .content .message {
    font-size: 1.3rem !important;
    padding-left: 15px;
    padding-right: 15px;
    text-align: center !important;
}

.banner-community .content .actions {
    text-align: center !important;
}

.banner-community .action {
    margin-top: 1rem;
    background-color: rgb(var(--v-theme-color1));
    color: rgb(var(--v-theme-white));
}

.banner-community .action:hover {
    background-color: rgba(var(--v-theme-color1), 0.8);
    box-shadow: 0 0px 25px rgba(var(--v-theme-invert), 0.5) !important;
}
</style>

<style scoped>
.banner-community {
    background: transparent;
}
</style>